<template>
  <div
    class="cart-list-item list-item"
    :class="{'card-error': item.error, 'active': inputFocused}">
    <div class="list-item-content">
      <div class="list-item-title text-start h7-text-medium black--text mb-1">
        <slot
          :item="item"
          name="item-title">
          <span
            v-if="item.lotNumber"
            data-qa="lotNumber">
            #{{ item.lotNumber }}
          </span>
          <span data-qa="lotName">{{ getName(item) }}</span>
        </slot>
      </div>
      <div
        :class="['list-item__additional-info text-start h8-text secondary__green_not_active--text']">
        <slot
          :item="item"
          name="item-additional">
          <div
            v-if="useAmount && !inputFocused && measureSmall"
            class="list-item-count__text"
            data-qa="UnitOfMeasurement"
            :title="measure">
            {{ $t('Planning.Amount') }}: {{ $n(item.quantity) }} {{ measureSmall }}
          </div>
          <div
            :class="['additional-info']">
            <div
              v-if="getGropTitle(item)"
              class="mt-1"
              data-qa="GropTitle">
              {{ getGropTitle(item) }}
            </div>
            <div
              v-if="item.description || item.comment"
              class="mt-1"
              data-qa="Description">
              {{ bigFirstLetter($t('Tenders.AdditionalDescription')) }}: {{ item.description || item.comment }}
            </div>
            <div
              v-if="useAmount"
              class="list-item-count__row">
              <div class="list-item-count__row-label">
                {{ $t('Planning.Amount') }}
              </div>
              <sInputNumber
                clearable
                :currency="measureSmall"
                data-qa="list-item-count"
                :disabled="loading"
                :max="999999999"
                :min="0"
                placeholder="0"
                :precision="3"
                :use-thousand-separator="true"
                :value.sync="item.quantity"
                @blur="inputFocused = false"
                @focus="inputFocused = true"/>
            </div>
          </div>
        </slot>
      </div>
    </div>
    <div :class="['list-item-action', {'active': popover} ]">
      <slot
        :item="item"
        name="item-action">
        <v-menu
          bottom
          close-on-click
          content-class="card-list-menu elevation-0"
          left
          offset-x
          offset-y>
          <template v-slot:activator="{ on }">
            <div
              v-on="loading ? '' : on">
              <sButton
                small
                type="text">
                <sIcon
                  color="var(--black-color)"
                  type="menu"/>
              </sButton>
            </div>
          </template>
          <div
            class="cart-list-options-menu">
            <slot
              :item="item"
              name="edit"/>
            <div
              class="list-item options-item"
              @click="$emit('delete')">
              <sIcon
                class="list-item-icon my-auto"
                type="delete"/>
              <div class="list-item-title h11-links ">
                {{ $t('Purchasing.Remove') }}
              </div>
            </div>
          </div>
        </v-menu>
      </slot>
    </div>
  </div>
</template>
<script>
import { modalMixin } from 'mixins'

export default {
  name: 'cartCard',
  mixins: [ modalMixin ],
  data() {
    return {
      popover: false,
      inputFocused: false,
      measureSmall: null,
      measure: null,
    }
  },
  props: {
    item: Object,
    getMeasur: {
      type: Function,
      default: () => {}
    },
    getGroup: {
      type: Function,
      default: () => {}
    },
    getName: {
      type: Function,
      default: () => {}
    },
    loading: Boolean,
    useAmount: {
      type: Boolean,
    }
  },
  methods: {
    getGropTitle(item) {
      return this.getGroup(item) || item?.group?.title
    },
  },
  watch: {
    item: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.measureSmall = this.getMeasur(newValue)
        this.measure = this.getMeasur(newValue, true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-list-menu {
  z-index: 700 !important;
  background: var(--v-main__light_green-base) !important;
  border: 1px solid var(--color-main-green) !important;
}
.card-error {
  border: 1px solid var(--color-error);
  box-shadow: 0px 0px 4px 0px var(--color-error) !important;
  color: var(--color-error) !important;
  .black--text {
    color: var(--color-error) !important;
  }
}
.cart-list-item.list-item {
  background-color: var(--v-secondary__green_chosen-base);
  border-radius: 8px;
  min-height: 28px;
  transition: 0.25s all;
  grid-template-columns: 1fr 30px;
  gap: 3px;
  display: grid;
  padding: 8px 8px 0 16px;
  .list-item-content {
    //max-width: calc(100% - 30px);
    padding-top: 4px;
    width: 100%;
  }
  .list-item-action  {
    width: 30px;
    min-width: 30px;
  }
  .list-item-action {
    opacity: 0;
    &.active {
      opacity: 1;
    }
  }
  .additional-info {
    display: none;
  }
  &.active,
  &:hover {
    .list-item-count__text {
      display: none;
    }
    .list-item-content {
      padding-right: 0;
    }
    .list-item-action {
      opacity: 1;
    }
    .additional-info {
      display: block;
    }
  }
}
.list-item__title, .list-item__additional-info {
  white-space: normal;
}
.list-item-count__row {
  display: flex;
  margin-top: 5px;
  &-label {
    margin: auto 5px auto 0;
  }
}

</style>
